import { apiFetch } from "@core/http";
import type { CatalogEntry, PointRule, PointRuleInput } from "@core/types";

const base = "/v1/portal/points-engine/rules";

export type RuleScope = "member" | "referral";

export interface RulesListResult {
  rules: PointRule[];
  // RulesImpact del servidor (SPEC-212 §4, A4 de
  // human-resolution-spec-212.json): el cliente nunca lo recalcula.
  impact: { fullJourney: number; purchaseOnly: number };
}

export const listPointRules = (scope: RuleScope) =>
  apiFetch<RulesListResult>(`${base}?scope=${encodeURIComponent(scope)}`);

export const createPointRule = (input: PointRuleInput) =>
  apiFetch<PointRule>(base, { method: "POST", body: input });

export const editPointRule = (id: string, input: PointRuleInput) =>
  apiFetch<PointRule>(`${base}/${encodeURIComponent(id)}`, {
    method: "PUT",
    body: input,
  });

// El contrato recibe `confirmed` como query param, no en el cuerpo
// (openapi.d.ts: operations.portalInactivatePointRule.parameters.query).
export const inactivatePointRule = (id: string, confirmed: boolean) =>
  apiFetch<void>(
    `${base}/${encodeURIComponent(id)}?confirmed=${confirmed ? "true" : "false"}`,
    { method: "DELETE" },
  );

export interface RuleHistoryEntry {
  occurredAt: string;
  username?: string | null;
  description: string;
  valuesBefore?: Record<string, unknown>;
  valuesAfter?: Record<string, unknown>;
}

export const pointRuleHistory = (id: string) =>
  apiFetch<RuleHistoryEntry[]>(`${base}/${encodeURIComponent(id)}/history`);

// EXTRA (human-resolution-spec-212.json): el catálogo de acciones vive bajo
// el módulo de permiso `catalogs`, distinto de `points_engine`. Se carga
// solo al abrir el editor en modo crear — para listar y editar alcanza con
// `PointRule.action`, ya embebido en cada regla. Llamada directa (no se
// importa `features/catalogs/api.ts`: esta feature no depende de otra).
export const listActionCatalog = (scope: RuleScope) =>
  apiFetch<CatalogEntry[]>(
    `/v1/portal/catalogs/${scope === "member" ? "member-actions" : "referral-actions"}/entries`,
  );
